<style>body.z-set-hide-staff .zoezi-staff,
body.z-set-hide-navigation .zoezi-appbar,
body.z-set-hide-mobile-navigation .zoezi-bottombar,
body.z-set-hide-header .zoezi-text-next.bgblur,
body.z-set-hide-site-selector .zoezi-appbar .zoezi-site-selector{
	display:none !important;
}</style>
<template><div id="zoezi-easy-settings"></div></template>
<script>export default {
    props: {
        hideHeaderText: {
            title: 'Dölj text på omslagsbild',
            type: Boolean,
            default: false
        },
        hideSiteSelector: {
            title: 'Dölj anläggningsval i meny',
            type: Boolean,
            default: false
        },
        hideNavigation: {
            title: 'Dölj navigation och sidhuvud',
            type: Boolean,
            default: false
        },
        hideMobileNavigation: {
            title: 'Dölj mobilnavigation',
            type: Boolean,
            default: false
        },
        hideStaff: {
            title: 'Dölj personallista',
            type: Boolean,
            default: false
        },
    },
    watch: {
        "$route.path"(value) {
            this.changeSettingsClasses();
        }
    },
    methods: {
        changeSettingsClasses: function(){
            if(this.hideHeaderText) document.body.classList.add('z-set-hide-header');
            else document.body.classList.remove('z-set-hide-header');
            if(this.hideSiteSelector) document.body.classList.add('z-set-hide-site-selector');
            else document.body.classList.remove('z-set-hide-site-selector');

            if(this.hideNavigation) document.body.classList.add('z-set-hide-navigation');
            else document.body.classList.remove('z-set-hide-navigation');
            if(this.hideMobileNavigation) document.body.classList.add('z-set-hide-mobile-navigation');
            else document.body.classList.remove('z-set-hide-mobile-navigation');
            if(this.hideStaff) document.body.classList.add('z-set-hide-staff');
            else document.body.classList.remove('z-set-hide-staff');
        }
    },
    mounted: function(){
        this.changeSettingsClasses();
	}
}</script>